import { MaterialIcons } from '@expo/vector-icons';

import { colors } from '@pletly/ui';

export const PlayIcon = () => {
	return <MaterialIcons name="play-arrow" size={68} color={colors.white} />;
};
